import { AppState } from 'src/store';
import { createSelector } from 'reselect';
import { get } from 'lodash';
import { projectState, StateSelection } from 'src/components/ListGridPair/ListGridPair.selectors';
import { NAME } from 'src/utils/Domain/Constants';

import { getDataFromCache, isDataLoaded } from 'src/services/pivotServiceCache';
import { getConfigureModalAggBys } from '../../StyleColorReview/StyleColorReview.slice';
import { AdornmentType } from 'configuration-schemas/viewdefns/literals';
import type { HistoryGridOwnProps } from 'configuration-schemas/ownProps';

function selectState(state: AppState, ownProps: HistoryGridOwnProps): StateSelection {
  const { nestedView: viewState } = state.pages.hindsighting.historyGrid;
  const { title, defns, hideCompanion, keys, showFlowStatus } = ownProps;
  const { viewDataState, isConfigLoading, viewDefns, aggBys: currentAggBys } = viewState;
  const treeData = getDataFromCache(viewState)?.tree || [];
  const configLoaded = !viewState.isConfigLoading;
  const dataLoaded = isDataLoaded(viewDataState);
  const adornments: AdornmentType[] = get(viewState.viewDefns.grid, 'adornments', []);

  // Need to have the same aggBys that the data was requested with;
  // currentAggBys is missing the bottom level so re-determining the aggBys here for proper data processing
  const aggBys = getConfigureModalAggBys(currentAggBys, defns.dataApi).split(',');

  return {
    identityField: keys ? keys.idProp : NAME,
    subheaderState: state.subheader,
    configLoaded,
    dataLoaded,
    treeData,
    title,
    subheaderViewDefns: defns.subheader,
    shouldFilterFlowStatus: false,
    activeTab: state.perspective.activeTab,
    isConfigLoading,
    viewDefns,
    aggBys,
    viewDataState,
    hideCompanion,
    adornments,
    allowWorklistFunctionality: false,
    showFlowStatus,
    isCompanionCollapsed: state.uiPose.isCompanionCollapsed,
    subheaderErrorText: ownProps.subheaderErrorText,
  };
}
export const selectAndProjectState = createSelector(selectState, projectState);
